import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import GetYourQuote from "./sections/GetYourQuote";
import ServiceTerritory from "./sections/ServiceTerritory";
import OpeningHours from "./sections/OpeningHours";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <GetYourQuote />
      <ServiceTerritory />
      <OpeningHours />
      <Footer />
    </div>;
}